import { render, staticRenderFns } from "./CMoc.vue?vue&type=template&id=a3204664"
import script from "./CMoc.vue?vue&type=script&lang=js"
export * from "./CMoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3204664')) {
      api.createRecord('a3204664', component.options)
    } else {
      api.reload('a3204664', component.options)
    }
    module.hot.accept("./CMoc.vue?vue&type=template&id=a3204664", function () {
      api.rerender('a3204664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CMoc.vue"
export default component.exports